import { Download2Icon, Text, Tooltip } from '@blockworks/ui';

import { useVisualizationOptionsContext } from '../../../../context';
import { ExportExecutionResultsProps } from '../../../export-execution-results';
import { FeatureControlButton } from '../../../feature-control-button';

import { downloadVisualizationImage, useCloneVisualization } from './share-visualization.utils';

type DownloadUnbrandedVisualizationScreenshotProps = {
    visualization: ExportExecutionResultsProps['visualization'];
};

const DownloadUnbrandedVisualizationScreenshot = ({ visualization }: DownloadUnbrandedVisualizationScreenshotProps) => {
    const { features } = useVisualizationOptionsContext();
    const cloneVisualization = useCloneVisualization(features.dangerouslyAllowUnbrandedScreenshotDownloads);
    const { type: visualizationType, title } = visualization ?? {};

    const handleScreenshotAction = async () => {
        if (!visualizationType) {
            console.error('visualizationType is undefined', { visualizationType });
            return;
        }

        const visualizationClone = cloneVisualization.create();

        if (visualizationClone) {
            try {
                await downloadVisualizationImage(
                    visualizationClone,
                    visualizationType,
                    title,
                    features.dangerouslyAllowUnbrandedScreenshotDownloads,
                );
            } catch (err) {
                console.error(`Error downloading chart image`, err);
            } finally {
                cloneVisualization.cleanup(visualizationClone);
            }
        } else {
            console.error('Failed to clone visualization', { visualizationClone });
        }
    };

    if (!visualization || !features.dangerouslyAllowUnbrandedScreenshotDownloads) return null;

    return (
        <Tooltip variant="default" side="left">
            <Tooltip.Trigger asChild>
                <FeatureControlButton
                    intent="primary-soft"
                    icon={Download2Icon}
                    aria-label="Download Screenshot"
                    title="Download Screenshot"
                    onClick={handleScreenshotAction}
                />
            </Tooltip.Trigger>
            <Tooltip.Content hideArrow>
                <Text size="xs">Download Screenshot</Text>
            </Tooltip.Content>
        </Tooltip>
    );
};

export { DownloadUnbrandedVisualizationScreenshot };
